"use client"

import { Globe } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `GlobeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const GlobeIcon = component(Icon)({ as: Globe })
